import type { RouteObject } from 'react-router';
import { ProductsPage } from './ProductsPage';
import { BundlesPage } from './BundlesPage';
import { GalleryPage } from './GalleryPage';
import { BundleDetailPage, ProductDetailPage } from './DetailPages';
import { BundleFormPage } from './BundleFormPage';
import { ProductFormPage } from './ProductFormPage';

/** 产品资料：path 相对 /v2。产品分类没有单独的页，从「筛选 → 分类列表」以 sheet 打开（高保真 R7） */
export const routes: RouteObject[] = [
  { path: 'products', element: <ProductsPage /> },
  { path: 'products/new', element: <ProductFormPage mode="create" /> },
  { path: 'products/:id/edit', element: <ProductFormPage mode="edit" /> },
  { path: 'products/:id/copy', element: <ProductFormPage mode="copy" /> },
  { path: 'products/:id', element: <ProductDetailPage /> },
  { path: 'bundles', element: <BundlesPage /> },
  { path: 'bundles/new', element: <BundleFormPage mode="create" /> },
  { path: 'bundles/:id/edit', element: <BundleFormPage mode="edit" /> },
  { path: 'bundles/:id/copy', element: <BundleFormPage mode="copy" /> },
  { path: 'bundles/:id', element: <BundleDetailPage /> },
  { path: 'gallery', element: <GalleryPage /> },
];
